import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import da from './da.json';
import en from './en.json';

const STORAGE_KEY = 'resordo_language';

const stored = typeof window !== 'undefined' ? localStorage.getItem(STORAGE_KEY) : null;

i18n.use(initReactI18next).init({
  resources: {
    da: { translation: da },
    en: { translation: en },
  },
  lng: stored ?? 'da',
  fallbackLng: 'da',
  interpolation: { escapeValue: false },
});

i18n.on('languageChanged', (lng) => {
  if (typeof window !== 'undefined') {
    localStorage.setItem(STORAGE_KEY, lng);
  }
});

export default i18n;
